<template>
  <div>
    <b-form ref="smsForm" role="form">
      <b-row>
        <b-col cols="12">
          <b-form-group label="Select Template">
            <el-select v-model="form.sms_template_id" filterable @change="setSmsContent">
              <el-option v-for="(itm,index) in smsTemplates" :key="index" :label="itm.sms_title"
                :value="itm.sms_template_id">
              </el-option>
            </el-select>
          </b-form-group>
        </b-col>
        <b-col cols="12">
          <b-form-group label="Message">
            <b-form-textarea v-model="form.sms_content" rows="3" required></b-form-textarea>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="6" cols="12" class="mx-auto text-center mt-4 pt-2">
          <el-button type="primary" class="w-100" :loading="is_loading_btn" @click="submit()">Send SMS</el-button>
        </b-col>
      </b-row>
    </b-form>
  </div>
</template>

<script>

import { Table, TableColumn, DropdownMenu, DropdownItem, Dropdown, Tooltip, Select, Option, Button } from 'element-ui'
import { swal } from '@/assets/js/httpImports.js'
import { mapActions, mapState } from 'pinia';
import { useMessagingStore } from '@/stores/messagingStore';

export default {
  name: 'send-sms-tab',
  props: [
    'smsProfile'
  ],
  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    [Tooltip.name]: Tooltip,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [Button.name]: Button,
  },
  data() {
    return {
			is_loading_btn:false,
      smsTemplates: [],
			form: {
				sms_template_id: null,
				sms_title: '',
				sms_content: '',
			}
    }
  },
  created() {
    this.getSmsTemplates().then(resp => {
      this.smsTemplates = resp;
    });
  },
  methods: {
    ...mapActions(useMessagingStore, ['getSmsTemplates', 'sendSms']),
		setSmsContent(value) {
			const smsTmp = this.smsTemplates.find(itm => itm.sms_template_id == value);
			if (!_gHlp.isEmpty(smsTmp)) {
				this.form.sms_title = smsTmp.sms_title;
				this.form.sms_content = smsTmp.sms_content;
			}
		},
    submit() {
			this.is_loading_btn = true;
			const postData = {
				owner_type: this.smsProfile.owner_type,
				owner_id: this.smsProfile.owner_id,
				sms_number: this.smsProfile.contact_no,
				sms_content: this.form.sms_content
			}
			swal.fire({
				title: "Attention",
				text: "Are you sure you want to send this?",
				icon: "info",
				confirmButtonText: 'Confirm',
				showCancelButton: true,
			}).then(async (result) => {
				if (result.isConfirmed) {
					const sendResult = await this.sendSms(postData);
					if(sendResult) {
						this.notifySuccess('<b>SMS: </b> - Successfully Sent.', 2000)
						this.$emit('getSmsHistory',this.smsProfile)
					}
				}
				this.is_loading_btn = false;	
			});


    }
  },
}

</script>